import React from "react";
import { Tabs } from "antd";
import ShippingCompanyList from "../../components/setting-conponents/Shipping/ShippingCompanyList";
import ShippingLocationList from "../../components/setting-conponents/Shipping/ShippingLocationList";
import ShippingPackingLIst from "../../components/setting-conponents/Shipping/ShippingPackingLIst";
import DeliverCompanyList from "../../components/setting-conponents/Shipping/DeliverCompanyList";

import DeliverCompanyListModal from "../../components/setting-conponents/Shipping/DeliverCompanyListModal";
import ShippingPackingLIstModal from "../../components/setting-conponents/Shipping/ShippingPackingLIstModal";
import ShippingLocationListModal from "../../components/setting-conponents/Shipping/ShippingLocationListModal";
import ShippingCompanyListModal from "../../components/setting-conponents/Shipping/ShippingCompanyListModal";

export default function ShippingSettingView() {
  const [activeTab, setActiveTab] = React.useState("DeliverCompany");
  
  const tableRef = React.useRef(null);

  const items = [
    {
      key: "DeliverCompany",
      label: "บริษัทขนส่ง",
      children: <DeliverCompanyList isDone={false} ref={tableRef} />,
    },
    {
      key: "ShippingCompany",
      label: "บริษัท Shipping",
      children: <ShippingCompanyList isDone={false} ref={tableRef} />,
    },
    {
      key: "location",
      label: "ด่าน (Location)",
      children: <ShippingLocationList isDone={false} ref={tableRef} />,
    },
    {
      key: "packing",
      label: "Packing",
      children: <ShippingPackingLIst isDone={false} ref={tableRef} /> 
    },
  ];

  const refreshData = async () => {
    if (tableRef.current) {
      await tableRef.current.fetchTable();
    }
  };

  return (
    <div style={{ marginTop: 20 }}>
      <Tabs
        destroyInactiveTabPane
        defaultActiveKey="DeliverCompany"
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        style={{ marginTop: 15 }}
      />
      <ShippingCompanyListModal
        open={false}
        onClose={() => {}}
        onUpdate={() => refreshData()}
        target={null}
      />
      <ShippingLocationListModal
        open={false}
        onClose={() => {}}
        onUpdate={() => refreshData()}
        target={null}
      />
      <ShippingPackingLIstModal
        open={false}
        onClose={() => {}}
        onUpdate={() => refreshData()}
        target={null}
      />
      <DeliverCompanyListModal
        open={false}
        onClose={() => {}}
        onUpdate={() => refreshData()}
        target={null}
      />
    </div>
  );
}
